<template>
  <div class="full-length-block">
   <div class="content-code">
      <div class="bottomRight-request">
         <p>{{$t('ExampleRequest')}}</p>
         <p>{{$t('placestop')}}</p>
      </div>
      <div class="preload-bg">
         <div class="preloadURL">
            <p>{{$t('curlGET')}} <span ref="url_link_add">'http://server-address:port/api/v2/trading/placestop?token=YoC1Buiy&trade=123123&price=1.0099'</span></p>
         </div>
         <a href="#" @click.prevent="$parent.$parent.handleCopy($refs.url_link_add)" class="copyURL"><feather type="copy"></feather> </a>
      </div>
   </div>
   <div class="content">
      <div class="overflow-hidden content-section" id="content-get-started">
         <div class="api-information">
            <div class="folder-name">
               <p class="headTitle">{{$t('trading')}}</p>
            </div>
            <div class="folder-description"></div>
         </div>
         <div class="api-information">
            <div class="heading">
               <div class="name addIcon">
                  <span class="GET method green" :title="$t('GET')">{{$t('GET')}}</span>
                  {{$t('placestop')}} 
                  <feather type="lock"></feather>
                  <span class="lock-icon"></span>
               </div>
            </div>
            <div class="url">http://server-address:port/api/v2/trading/placestop?token=YoC1Buiy&trade=123123&price=1.0099</div>
            <div class="description request-description">
               <p>{{$t('placestopMsz')}}</p>
               <div class="desc_code">
                  <pre class="click-to-expand-wrapper is-snippet-wrapper  language-undefined" :class="(read_more)?'is-expandable':''">
                                <code class=" is-highlighted language-undefined">{
    "success": true,
    "message": "",
    "result": {
        "OrderID": 247574778
    }
}
                                </code>
                            </pre>
                  <div class="expandMore">
                     <a class="showMore-btn" v-if="!read_more" href="#" @click.prevent="read_more = true">{{$t('ReadMore')}}</a>  
                     <a class="showLess-btn" v-if="read_more" href="#" @click.prevent="read_more = false">{{$t('ReadLess')}}</a>  
                  </div>
               </div>
            </div>
            <div class="authorization-info" id="auth-info-">
               <!-- <div class="heading"> AUTHORIZATION <span class="auth-type"> Digest Auth </span> </div>
                  </div>  -->
               <div class="query-params">
                  <div class="heading">{{$t('PARAMS')}}</div>
                  <hr>
                  <div class="param row justify-content-end">
                     <div class="name col-md-3 col-xs-12">{{$t('token')}}</div>
                     <div class="value col-md-9 col-xs-12">YoC1Buiy</div>
                     <div class="description col-md-9 col-xs-12">
                        <p>{{$t('sessionToken')}}</p>
                     </div>
                  </div>
                  <div class="param row justify-content-end">
                     <div class="name col-md-3 col-xs-12">{{$t('trade')}}</div>
                     <div class="value col-md-9 col-xs-12">123123</div>
                     <div class="description col-md-9 col-xs-12">
                        <p>{{$t('openPositionNumber')}}</p>
                     </div>
                  </div>
                  <div class="param row justify-content-end">
                     <div class="name col-md-3 col-xs-12">{{$t('price')}}</div>
                     <div class="value col-md-9 col-xs-12">1.0099</div>
                     <div class="description col-md-9 col-xs-12">
                        <p>{{$t('orderPrice')}}</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
</template>

<script>
export default {
   data(){
        return {
            read_more: false,
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/api_document/trading/placestop.vue